<script setup lang="ts">
/**
 * Компонент пустого состояния при фильтрации
 * Показывается когда фильтры активны, но не дают результатов
 */
const emit = defineEmits<{
  /** Событие сброса фильтров */
  'reset': [];
}>();
</script>

<template>
  <div class="empty-filter-results">
    <div class="empty-icon">
      <UIcon name="i-heroicons-funnel-solid" class="w-16 h-16 text-gray-300 dark:text-gray-600" />
      <UIcon name="i-heroicons-x-mark-solid" class="w-8 h-8 text-red-500 absolute -top-1 -right-1" />
    </div>
    
    <h3 class="empty-title">Нет результатов</h3>
    <p class="empty-description">
      По выбранным фильтрам ничего не найдено. 
      <br class="hidden sm:block" />
      Попробуйте изменить или сбросить фильтры.
    </p>
    
    <button
      @click="emit('reset')"
      class="empty-button"
      type="button"
    >
      <UIcon name="i-heroicons-arrow-path" class="w-5 h-5" />
      <span>Сбросить фильтры</span>
    </button>
  </div>
</template>

<style scoped lang="scss">
.empty-filter-results {
  @apply flex flex-col items-center justify-center py-16 px-4 text-center;
  min-height: 400px;
}

.empty-icon {
  @apply relative mb-6;
  animation: float 3s ease-in-out infinite;
}

.empty-title {
  @apply text-2xl font-bold text-gray-800 dark:text-gray-200 mb-3;
}

.empty-description {
  @apply text-base text-gray-600 dark:text-gray-400 mb-6 max-w-md;
}

.empty-button {
  @apply inline-flex items-center gap-2 px-6 py-3 
         bg-red-600 hover:bg-red-700 dark:bg-red-700 dark:hover:bg-red-600
         text-white font-medium rounded-lg
         transition-all duration-200
         hover:shadow-lg hover:scale-105 active:scale-95;
}

/* Анимация плавающей иконки */
@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

/* Адаптивность */
@media (max-width: 640px) {
  .empty-filter-results {
    @apply py-12;
    min-height: 300px;
  }
  
  .empty-icon {
    @apply mb-4;
    
    :deep(.w-16) {
      @apply w-12 h-12;
    }
    
    :deep(.w-8) {
      @apply w-6 h-6;
    }
  }
  
  .empty-title {
    @apply text-xl mb-2;
  }
  
  .empty-description {
    @apply text-sm mb-4;
  }
  
  .empty-button {
    @apply px-5 py-2.5 text-sm;
  }
}
</style>

